/** Presentation only: preserve original identifiers in requests and exports. */
export function compactPublicId(value: string): string {
  return value.length > 10 ? `${value.slice(0, 4)}…${value.slice(-4)}` : value;
}

export function isReportPublicId(
  column: string,
  value: unknown
): value is string {
  return (
    /^(?:id(?:\b|_)|идентификатор(?:\s|$))/i.test(column.trim()) &&
    typeof value === "string" &&
    /^[0-9A-Za-z]{16}$/.test(value)
  );
}
